import http from './http';

export async function listKnowledge() {
  const { data } = await http.get('/ai/knowledge');
  return data;
}

export async function createKnowledge(payload) {
  const { data } = await http.post('/ai/knowledge', payload);
  return data;
}

export async function updateKnowledge(id, payload) {
  const { data } = await http.put(`/ai/knowledge/${id}`, payload);
  return data;
}

export async function deleteKnowledge(id) {
  await http.delete(`/ai/knowledge/${id}`);
}
